module.exports = __webpack_public_path__ + "static/media/card2_4.eede97da.png";